import "../../assets/css/educlip.scss";
import Header from "../../components/header";

import svgLogo from "../../assets/images/landing/logo.svg";
import svgNaverblog from "../../assets/images/landing/naverblog.svg";
import { logout } from "../../api/auth";
import { SessionStorageUtil } from "../../utils/session_storage_util";

import { useSearchParams } from "react-router-dom";
import { useDonationModal } from "../../hooks/use_donation_modal";
import DonationModalContainer from "../../components/modal/donate_modal_container";
import { useSubSalesValidation } from "../../hooks/use_sub_sales_validation";
import educlipMainKids from "../../assets/images/educlip/educlip_main_kids.png";
import educlipBanner from "../../assets/images/educlip/educlip_top_banner.png";
import educlipBannerBg from "../../assets/images/educlip/educlip_banner.png";
import educlipFeature2 from "../../assets/images/educlip/educlip_feature2.png";
import { useEffect, useState } from "react";

function EduClipPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");
  const userRef = searchParams.get("usridx");

  const donationModal = useDonationModal();

  useSubSalesValidation(kdBusiness);

  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const [headerScrolled, setHeaderScrolled] = useState(false);
  const isLoggedIn = !!SessionStorageUtil.getItem("accessToken");

  const courses = {
    grade1: [
      {
        category: "수학",
        title:
          "제 51회 전국 영어/수학 학력경시대회 대비 기출문제 온라인 특강[수학-초1]",
        description: "대회 기출문제 특강",
        subDescription: "김다은 선생님",
        detail: ["강의수: 18강"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "20",
      },
    ],
    grade2: [
      {
        category: "수학",
        title:
          "제 51회 전국 영어/수학 학력경시대회 대비 기출문제 온라인 특강[수학-초2]",
        description: "대회 기출문제 특강",
        subDescription: "이정경 선생님",
        detail: ["강의수: 15강"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "21",
      },
    ],
    grade3: [
      {
        category: "수학",
        title:
          "제 51회 전국 영어/수학 학력경시대회 대비 기출문제 온라인 특강[수학-초3]",
        description: "대회 기출문제 특강",
        subDescription: "이예하 선생님",
        detail: ["강의수: 18강"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "6",
      },
    ],
    grade4: [
      {
        category: "수학",
        title:
          "제 51회 전국 영어/수학 학력경시대회 대비 기출문제 온라인 특강[수학-초4]",
        description: "대비 기출문제 특강",
        subDescription: "김정은 선생님",
        detail: ["강의수: 18강"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "7",
      },
    ],
    grade5: [
      {
        category: "수학",
        title:
          "제 51회 전국 영어/수학 학력경시대회 대비 기출문제 온라인 특강[수학-초5]",
        description: "대비 기출문제 특강",
        subDescription: "정주창 선생님",
        detail: ["강의수: 15강"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "8",
      },
    ],
    grade6: [
      {
        category: "수학",
        title:
          "제 51회 전국 영어/수학 학력경시대회 대비 기출문제 온라인 특강[수학-초6]",
        description: "대비 기출문제 특강",
        subDescription: "신희백 선생님",
        detail: ["강의수: 15강"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "9",
      },
    ],
  };

  const features = [
    {
      title: "경시대회 대비 초등학생 3학년 ~ 6학년 학생들에게 도움 제공",
      description:
        "전문 강사진들이 국내 최고 수준급 수학경시대회를 준비하는 모든 학생들에게 도움 제공",
    },
    {
      title: "난이도별(상, 중, 하) 강의 구성을 통해 수준대별 학습",
      description:
        "기출문제 풀이를 통한 출제경향 및 문제유형 파악, 시험 철저대비",
    },
    {
      title: "커리큘럼",
      description: "총 15강으로 구성된 전문 강사를 통한 깊이있는 기출문제 특강",
    },
  ];

  const faqs = [
    {
      question: "환불은 가능한가요?",
      answer:
        "네, 에듀클립 환불 규정에 따라 진행됩니다.<br /><a href='https://kidsda.com/application/service#sec-12' target='_blank'>[환불정책 바로가기]</a> 자세한 환불정책을 확인하실 수 있습니다.",
    },
    {
      question: "어떻게 수강하나요?",
      answer:
        "구매하신 에듀클립 수강권을 '키즈다' 앱 내에 에듀클립 메뉴에서 쿠폰을 사용하여, 구매하신 특강을 수강하실 수 있습니다.",
    },
    {
      question: "어떤 디바이스를 지원하나요?",
      answer: "PC/태블릿/모바일 웹을 지원합니다. 자동재생은 사용하지 않습니다.",
    },
    {
      question: "수강 기간은 어떻게 되나요?",
      answer: "결제일로부터 30일간 이용 가능하며, 자동 갱신됩니다.",
    },
    {
      question: "형제 할인이 있나요?",
      answer: "2명 이상 동시 등록 시 10% 할인이 적용됩니다.",
    },
  ];

  // FAQ 토글 함수
  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const handleLogout = async () => {
    await logout();
    window.location.href = "/login";
  };

  useEffect(() => {
    document.body.style.background = "white";

    const handleScroll = () => {
      setHeaderScrolled(window.scrollY > 8);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="educlip-body">
      <Header variant="educlip" scrolled={headerScrolled} />

      <main>
        {/* Hero */}
        <section className="edu-hero ring-off">
          <div className="edu-container edu-hero-grid">
            <div className="edu-hero-copy">
              <span className="edu-eyebrow">
                <i className="fas fa-play-circle"></i> 에듀클립 온라인 특강
              </span>
              <h1 className="edu-hero-title">
                영어 · 수학 학력경시대회
                <br />
                완벽 대비 강의
              </h1>
              <p className="edu-hero-sub">
                핵심 기출문제 강의로 아이의 실력과 자신감을 키워줍니다.
                <br />
                학년별 맞춤 커리큘럼으로 체계적으로 학습하세요.
              </p>
            </div>
            <div className="edu-hero-characters">
              <img src={educlipMainKids} alt="에듀클립" />
            </div>
          </div>
        </section>

        {/* 히어로 하단 배너 */}
        <section className="edu-hero-banner">
          <div className="edu-container">
            <img src={educlipBanner} alt="에듀클립 배너" />
          </div>
        </section>

        {/* 교육 플랫폼 카드 */}
        <section className="edu-programs">
          <div className="edu-container">
            <h2 className="edu-section-title">교육 플랫폼</h2>

            {Object.entries(courses).map(([grade, items], index) => (
              <div key={grade} className="edu-grade-group">
                <h3 className="edu-grade-badge">{index + 1}학년</h3>
                <div className="edu-cards">
                  {items.map((course, idx) => (
                    <article
                      key={idx}
                      className="edu-card"
                      onClick={() => {
                        donationModal.startDonationProcess(course.productSeq);
                      }}
                    >
                      <span className="edu-card-cap">{course.category}</span>
                      <h3 className="edu-card-title">{course.title}</h3>
                      <p className="edu-card-subtitle">{course.description}</p>
                      <p className="edu-card-teacher">
                        {course.subDescription}
                      </p>
                      {course.detail && (
                        <div className="edu-card-meta">
                          {course.detail.map((value, i) => (
                            <span key={i}>{value}</span>
                          ))}
                        </div>
                      )}
                      <hr className="edu-card-divider" />
                      <div className="edu-card-footer">
                        <span className="edu-price">
                          {course.price} <small>{course.tag}</small>
                        </span>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <div class="edu-band">
          <div class="edu-container">
            <div
              class="edu-band-inner"
              style={{ backgroundImage: `url(${educlipBannerBg})` }}
            ></div>
          </div>
        </div>

        {/* 상품 안내 */}
        <section className="edu-assure">
          <div className="edu-container">
            <h2 className="edu-section-title">상품 안내</h2>
            <div className="edu-assure-grid">
              <div className="edu-assure-badge">
                <div className="edu-assure-mascot">
                  <img src={educlipFeature2} alt="에듀클립" />
                </div>
                <h3 className="edu-assure-title is-one-line">
                  전국 영어 · 수학 학력경시대회
                </h3>
                <p className="edu-assure-desc">
                  수학경시대회 전문 강사를 통한 깊이있는 기출문제 특강,
                  <br />
                  난이도별 맞춤 강의로 문제 해결 접근법과 실전 감각을
                  키워줍니다.
                </p>
                <ul className="edu-assure-features">
                  <li>
                    기출문제 풀이를 통한 출제경향 및 문제유형 파악, 시험
                    철저대비
                  </li>
                  <li>난이도별(상, 중, 하) 강의 구성을 통해 수준대별 학습</li>
                  <li>KMO, 성대경시대회, KMC 경시대회 전문 강사진</li>
                  <li>
                    국내 최고 수준급 수학경시대회를 준비하는 모든 학생들에게
                    도움 제공
                  </li>
                </ul>
              </div>
              <div className="edu-assure-list">
                {features.map((feature, idx) => (
                  <div key={idx} className="edu-alist">
                    <strong>{feature.title}</strong>
                    <p>{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="edu-faq">
          <div className="edu-container">
            <h2 className="edu-section-title">자주 묻는 질문</h2>
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className={`edu-faq-item ${openFaqIndex === idx ? "faq-open" : ""}`}
              >
                <div className="edu-faq-summary" onClick={() => toggleFaq(idx)}>
                  <span>{faq.question}</span>
                  <span className="edu-faq-icon">
                    {openFaqIndex === idx ? "−" : "+"}
                  </span>
                </div>
                {openFaqIndex === idx && faq.answer && (
                  <div
                    className="edu-faq-answer"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  ></div>
                )}
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="edu-footer footer-light">
        <div className="edu-container">
          <div className="footer-mid">
            <div className="footer-info">
              <div className="footer-logo">
                <img
                  src={svgLogo}
                  alt="키즈다"
                  className="logo-svg logo-svg-white"
                />
              </div>
              <div className="footer-details">
                <p>
                  <strong>(주)위고컴퍼니</strong> | 대표:{" "}
                  <strong>김영기</strong> | 사업자번호:{" "}
                  <strong>339-87-00990</strong>
                </p>
                <p>
                  경기도 화성시 동탄대로5길 21 4층 E420-A26호 (송동, 라크몽)
                  <br />
                  대표전화: 02-3288-3455 | 청소년보호책임자: 김준영
                </p>
                <p>통신판매업등록번호: 2021-화성동탄-0946 | 제호: 키즈다</p>
              </div>
            </div>

            <div className="footer-links-group">
              <div className="footer-col">
                <a href="/">서비스 소개</a>
                <a href="/news">키즈다 소식</a>
                <a href="/product">구독</a>
                <a href="/educlip">에듀클립</a>
              </div>
              <div className="footer-col">
                <a href="/application/service" target="_blank" rel="noreferrer">
                  이용약관
                </a>
                <a href="/application/privacy" target="_blank" rel="noreferrer">
                  개인정보처리방침
                </a>
                {isLoggedIn && (
                  <button onClick={handleLogout} className="footer-logout-btn">
                    로그아웃
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p className="copyright">
              &copy; 2026 Kidsda Inc. All rights reserved.
            </p>
            <div className="social-links">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <i className="fab fa-youtube"></i>
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://blog.naver.com"
                target="_blank"
                rel="noreferrer"
                className="blog-icon"
                aria-label="네이버 블로그"
              >
                <img src={svgNaverblog} alt="네이버 블로그" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <DonationModalContainer
        {...donationModal}
        kdBusiness={kdBusiness}
        userRef={userRef}
        paymentType="card"
      />
    </div>
  );
}

export default EduClipPage;
